'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { useEffect, useRef } from 'react'

type ZendeskClientProps = {
  scriptKey: string
  isGlobalEnabled: boolean
  isLoginEnabled: boolean
}

export default function ZendeskClient({
  scriptKey,
  isGlobalEnabled,
  isLoginEnabled,
}: ZendeskClientProps) {
  const pathname = usePathname()
  const scriptLoadedRef = useRef(false)
  const isLoginPage = pathname.startsWith('/login')

  const shouldLoadNow = !!scriptKey && (isGlobalEnabled || (isLoginEnabled && isLoginPage))

  useEffect(() => {
    if (window.zE && scriptLoadedRef.current) {
      try {
        if (shouldLoadNow) {
          window.zE('webWidget', 'show')
        } else {
          window.zE('webWidget', 'hide')
        }
      } catch (err) {
        console.warn('[ZenDesk] Error showing/hiding help button:', err)
      }
    }
  }, [shouldLoadNow])

  if (!scriptKey || !shouldLoadNow) {
    return null
  }

  return (
    <Script
      id="ze-snippet"
      strategy="lazyOnload" // already includes defer
      src={`https://static.zdassets.com/ekr/snippet.js?key=${scriptKey}`}
      onLoad={() => {
        scriptLoadedRef.current = true

        if (window.zE) {
          try {
            if (shouldLoadNow) {
              window.zE('webWidget', 'show')
            } else {
              window.zE('webWidget', 'hide')
            }
          } catch (err) {
            console.warn('[ZenDesk] Error during init:', err)
          }
        }
      }}
      onError={() => {
        scriptLoadedRef.current = false
      }}
    />
  )
}
